'use client';

/**
 * Session context so that useCurrentUserProfile (and other core hooks) read session
 * from a single React tree. The app must wrap the tree with a provider that calls
 * useSession() from the app's auth client and sets this context (see AppSessionProvider
 * in the app). This avoids "Cannot read properties of null (reading 'useRef')" when
 * better-auth's useSession runs in a different React instance than the app.
 */

import { createContext, useContext } from 'react';

export type SessionContextValue = {
  data: { user?: { id?: string; name?: string; email?: string; image?: string | null; role?: string | null }; [k: string]: unknown } | null;
  isPending: boolean;
};

export const SessionContext = createContext<SessionContextValue | null>(null);

/**
 * Read session from context. Returns null if the app's session provider is not in the tree.
 */
export function useSessionFromContext(): SessionContextValue | null {
  return useContext(SessionContext);
}
